import React from 'react'
import { SimplesBlocksType } from '../features/render-block'
import { RenderBlock } from '../types'

export const ThemeContext = React.createContext<{
	separator?: {
		type: SimplesBlocksType.Staff.Separator
		color: string
	}
	lead?: RenderBlock.LeadFormData
}>({})
export const ThemeContextProvider = ThemeContext.Provider
export const ThemeContextConsumer = ThemeContext.Consumer

export const useThemeContext = () => {
	const ctx = React.useContext(ThemeContext)
	return ctx
}
